import { useEffect, useState } from "react";
import { Association } from "src/interfaces/Common";
import { PagesID } from "@utils/utilsConfigurations";
import { ServicesURL } from "@utils/utilsApi";

export const useAddEditBankAccount = (dataDetail?: any) => {
  interface CostCenter {
    id: number;
    sap_code: string;
  }

  const [openAssociations, setOpenAssociations] = useState<
    boolean | Association
  >(false);
  const [costCentersAssociation, setCostCentersAssociation] = useState<any>([]);

  const formatCostCenters = (cost_centers: any) => {
    const formattedCostCenter = cost_centers.map((center: CostCenter) => ({
      id: center.id,
      label: center.sap_code,
    }));
    setCostCentersAssociation(formattedCostCenter);
  };

  useEffect(() => {
    if (dataDetail?.cost_centers) {
      formatCostCenters(dataDetail.cost_centers);
    }
  }, [dataDetail]);

  const resetBankAccountAssociations = () => {
    if (dataDetail?.cost_centers) {
      formatCostCenters(dataDetail.cost_centers);
    } else {
      setCostCentersAssociation([]);
    }
  };

  const setOpenAssociation = (accessorKey: string, value: boolean) => {
    switch (accessorKey) {
      case "cost_centers":
        setOpenAssociations(
          value
            ? {
                accessorKey: "cost_centers",
                mediaType: "cost_centers",
                type: "table",
                titleKey: "cost-centers-association",
                pageId: PagesID["cost-centers"],
                service: ServicesURL.getCostCenters,
              }
            : value,
        );
        break;
    }
  };

  const getValues = (accessorKey: string) => {
    switch (accessorKey) {
      case "cost_centers":
        return costCentersAssociation;
    }
  };

  const handleDelete = (accessorKey: string, e: any) => {
    switch (accessorKey) {
      case "cost_centers":
        setCostCentersAssociation(
          costCentersAssociation.filter((element: any) => element.id !== e.id),
        );
        break;
    }
  };

  const handleAssociation = (accessorKey: string, value: any) => {
    switch (accessorKey) {
      case "cost_centers":
        const objToCostCentersAssociation: any = Object.keys(value).map(
          (key: string) => {
            if (key.includes("||")) {
              return {
                id: key.split("||")[0],
                label: key.split("||")[1],
              };
            } else {
              return costCentersAssociation.find(
                (elem: any) => elem.id === +key,
              );
            }
          },
        );
        setCostCentersAssociation(objToCostCentersAssociation);
        break;
    }
  };

  return {
    handleAssociation,
    setOpenAssociation,
    handleDelete,
    getValues,
    resetBankAccountAssociations,
    setCostCentersAssociation,
    costCentersAssociation,
    openAssociations,
  };
};
